module.exports = __webpack_public_path__ + "static/img/activity_background16.2567043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_background16.png
// module id = HQJ8
// module chunks = 128